"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const icons_material_1 = require("@mui/icons-material");
const material_1 = require("@mui/material");
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
/**
 *
 * Empty states occur when there is no content to display to the user, like a list without items, or a search that returns no results.
 * The goal of an empty state is to prevent confusion and help users continue with their tasks
  * In Argus we distinguish between three variations of empty state:
    - Empty search results
    - No data available
    - Initial empty state
 *
 * @internal
 *
 * @example Usage
 * ```tsx
 * <Emptystate
 *    title="No results"
 *    description="This search gave 0 results"
 *    Icon={AttachmentIcon}
 *    actionButtonProps={ children: "refresh page", onClick: () => console.log("refresh page"), }  />}
 * ```
 * @category component
 */
const EmptyState = (props) => {
    const { Icon = icons_material_1.CropFree, title, description = "", actionButtonProps } = props;
    const { palette } = (0, material_1.useTheme)();
    return (react_1.default.createElement(material_1.Grid, { container: true, display: "flex", flexDirection: "column", alignItems: "center" },
        react_1.default.createElement(material_1.Grid, { item: true, sx: { mb: 1 } },
            react_1.default.createElement(Icon, { fontSize: "large", sx: { height: "80px", width: "80px", color: palette.text.disabled } })),
        react_1.default.createElement(material_1.Grid, { item: true, sx: { mb: 1 } },
            react_1.default.createElement(Typography_1.default, { variant: "subtitle1", color: "textPrimary" }, title)),
        react_1.default.createElement(material_1.Grid, { item: true },
            react_1.default.createElement(Typography_1.default, { variant: "body2", color: "textSecondary" }, description)),
        actionButtonProps && (react_1.default.createElement(material_1.Grid, { item: true, sx: { mt: 2 } },
            react_1.default.createElement(material_1.Button, { variant: "outlined", ...actionButtonProps })))));
};
exports.default = EmptyState;
